/**
 * Determines if a language or locale uses right-to-left (RTL) text direction.
 * @param languageOrLocale - A 2-letter language code (e.g., 'ar', 'he', 'ur')
 *                           or locale string (e.g., 'ar-SA', 'he-IL', 'ur-PK', 'qa-AR')
 * @returns true if the language uses RTL text direction, otherwise false
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isRTL", {
    enumerable: true,
    get: function() {
        return isRTL;
    }
});
function isRTL(languageOrLocale) {
    if (!languageOrLocale || typeof languageOrLocale !== 'string') {
        return false;
    }
    const lowercased = languageOrLocale.toLowerCase();
    // Handle special QA pseudo Arabic locale
    if (lowercased === 'qa-ar') {
        return true;
    }
    const language = lowercased.split('-')[0];
    // RTL languages: Arabic, Hebrew, Urdu, Persian, Pashto, Syriac
    return language === 'ar' || language === 'he' || language === 'ur' || language === 'fa' || language === 'ps' || language === 'sy';
}
